export default __webpack_public_path__ + "static/media/fitbms.6a0f25d1.png";